import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/tower.svg'


const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "relative w-full" }
const _hoisted_3 = ["onchange", "disabled"]
const _hoisted_4 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QRCodeReader = _resolveComponent("QRCodeReader")!
  const _component_MessageError = _resolveComponent("MessageError")!
  const _component_Card = _resolveComponent("Card")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "bg-white w-10/12 z-10 flex flex-col p-8" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[3] || (_cache[3] = _createElementVNode("img", {
            src: _imports_0,
            class: "w-10 mr-4"
          }, null, -1)),
          _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.room) = $event)),
              onchange: _ctx.onSelectRoom,
              disabled: _ctx.qrCode !== '',
              class: "block w-full pl-3 pr-4 py-1 border border-blue-300 rounded-xl bg-white text-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
            }, [
              _cache[1] || (_cache[1] = _createElementVNode("option", {
                value: {},
                selected: ""
              }, "Escolha uma opção", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.roomsList, (room, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: index,
                  value: room
                }, _toDisplayString(room.name), 9, _hoisted_4))
              }), 128))
            ], 8, _hoisted_3), [
              [_vModelSelect, _ctx.data.room]
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("svg", {
              class: "absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500 pointer-events-none",
              width: "15",
              height: "9",
              viewBox: "0 0 15 9",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                d: "M1.5723 0H13.1934C14.2383 0 14.7608 1.26465 14.0235 2.00195L8.21292 7.8125C7.75394 8.27148 7.01175 8.27148 6.55765 7.8125L0.742221 2.00195C0.0049161 1.26465 0.527377 0 1.5723 0Z",
                fill: "#015ABB"
              })
            ], -1))
          ])
        ]),
        (_ctx.data.room.id)
          ? (_openBlock(), _createBlock(_component_QRCodeReader, {
              key: _ctx.qrStreamKey,
              readQRCode: _ctx.readQRCode
            }, null, 8, ["readQRCode"]))
          : _createCommentVNode("", true),
        (_ctx.data.room.id)
          ? (_openBlock(), _createBlock(_component_MessageError, {
              key: 1,
              message: _ctx.data.messageError
            }, null, 8, ["message"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.qrCode)
      ? (_openBlock(), _createBlock(_component_FooterComponent, {
          key: 0,
          room: _ctx.data.room,
          participant: _ctx.data.participant,
          clearData: _ctx.clearData
        }, null, 8, ["room", "participant", "clearData"]))
      : _createCommentVNode("", true)
  ], 64))
}